<template>
  <form class="form-horizontal new-lg-form" v-on:submit.prevent="recover">
      <div v-if="success">
        <div class="grid-x grid-padding-x align-center">
          <div class="cell text-center confirm">
                <i class="material-icons">check_circle</i>
                <h3>{{ $t('label.mailSent') }}</h3>
                <p>
                  {{ $t('label.checkMailRecover') }}
                </p>
            </div>
        </div>
      </div>
      <div v-if="!success">
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <h5>{{ $t('label.recoverPassword') }}</h5>
                <p class="text-muted">{{ $t('label.enterMailToSendInstro') }}</p>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <input type="text" required="true" placeholder="Email" v-model="mail">
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <span class="messageError beebeeLabel">{{error}}</span>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-6">
                <button class="button button-default expanded hovering ld-over" type="submit" v-on:click="recover" v-bind:class="running ? 'running' : ''">
                  {{ $t('label.recoverPassword') }}
                </button>
            </div>
            <div class="cell small-12 medium-6 text-right sideButton">
              <router-link to="/" class="link-underline">
                {{ $t('label.backLogin') }}
              </router-link>
            </div>
        </div>
      </div>
  </form>
</template>

<script>
import axios from 'axios'
import * as CONFIG from '../config'

export default {
  name: 'recover',
  data: () => ({
    mail: '',
    error: '',
    success: false,
    running: false
  }),
  created () {
    if (this.$route.query.mail) {
      this.mail = this.$route.query.mail
    }
  },
  methods: {
    recover () {
      var self = this

      if (this.running) {
        return false
      }

      if (!this.mail) {
        this.error = this.$t('label.emptyField')
        return false
      }

      this.error = ''
      self.running = true

      axios.get(`${CONFIG.BASEURL}/api/v1/users/forgot?mail=${this.mail}`, {
        cache: false
      })
        .then(response => {
          self.running = false
          console.log(response)
          self.success = true
        })
        .catch(function (reason) {
          self.running = false
          if (reason && reason.response && reason.response.data && reason.response.data.errors && reason.response.data.errors[0] && reason.response.data.errors[0].detail) {
            self.error = reason.response.data.errors[0].detail
          } else {
            self.error = self.$t('label.recoverPasswordError')
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Recover.vue